<template>
    <div
        :id="mapId"
        class="map-element"
        :style="{height: height}"
    />
</template>

<script>
    import 'leaflet/dist/leaflet';
    import { generateId } from '@nodes/helpers/string';

    export default {
        name: 'Map',

        props: {
            /**
             * Map Height
             */
            height: {
                type   : String,
                default: '500px',
            },

            /**
             * Zoom Initial Amount
             */
            zoom: {
                type   : [Number, String],
                default: 15,
            },

            /**
             * Initial Latitude
             */
            lat: {
                type    : [String, Number],
                required: true,
            },

            /**
             * Initial Longitude
             */
            lng: {
                type    : [String, Number],
                required: true,
            },

            /**
             * Marker Position
             * _lat,lng_
             */
            marker: {
                type: String,
            },

            /**
             * Popup message
             */
            popup: {
                type: String,
            },

            /**
             * Zoom Map on Scroll
             */
            scrollWheelZoom: {
                type   : Boolean,
                default: false,
            },

            /**
             * Marker Icon
             */
            markerIcon: {
                type: String,
            },

            /**
             * Marker Icon size
             */
            iconSize: {
                type   : Array,
                default: () => [25, 41],
            },

            /**
             * Marker Icon Anchor
             */
            iconAnchor: {
                type   : Array,
                default: () => [13, 41],
            },
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                map: null,
            };
        },

        computed: {
            /**
             * Generates Map Id
             *
             * @returns {string | *}
             */
            mapId() {
                return this.$attrs.id || generateId();
            },

            /**
             * Map-view Position
             *
             * @returns {*[]}
             */
            position() {
                return [this.lat, this.lng];
            },

            /**
             * Marker Position
             *
             * @returns {*}
             */
            markerPosition() {
                if (!this.marker) {
                    return null;
                }
                return this.marker.split(',');
            },

            /**
             *
             * @returns {*}
             */
            popupLayout() {
                if (!this.popup) {
                    return null;
                }
                return this.popup;
            },

            /**
             * Marker Position icon
             *
             * @returns {string}
             */
            iconUrl() {
                // eslint-disable-next-line global-require
                return this.markerIcon || require('./assets/map-marker.png'); // eslint-disable-line import/no-dynamic-require
            },
        },

        /**
         * @inheritDoc
         */
        mounted() {
            this.initMap();
        },

        methods: {
            /**
             * Init Leaflet Map
             */
            initMap() {
                const item = this.$el;
                const id = item.getAttribute('id');

                let map = L.map(id).setView(this.position, this.zoom); // eslint-disable-line
                map.panTo(new L.LatLng(this.position[0], this.position[1])); // eslint-disable-line

                this.map = map;

                // Disable zoom on scroll
                if (!this.scrollWheelZoom) {
                    map.scrollWheelZoom.disable();
                }

                let markerImage = L.icon({ // eslint-disable-line
                    iconUrl   : this.iconUrl,
                    iconSize  : this.iconSize,
                    iconAnchor: this.iconAnchor,
                });

                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { // eslint-disable-line
                    attribution: '',
                }).addTo(map);

                if (this.markerPosition) {
                    let marker = L.marker(this.markerPosition, { // eslint-disable-line
                        icon: markerImage,
                    }).addTo(map);

                    if (this.popupLayout) {
                        marker.bindPopup(this.popupLayout).openPopup();
                    }
                }
            },
        },

    };
</script>

<style lang="scss" src="./index.scss" />
